import { render, staticRenderFns } from "./kfr2site.vue?vue&type=template&id=4a2dfb3b&"
import script from "./kfr2site.vue?vue&type=script&lang=js&"
export * from "./kfr2site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports